import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const productAIService = {
    getAllProductAIs, 
    updateProductAIStatus,
    getProductAI,
    updateProductAI,
    createProductAI,
  };

const MODULE = {
    PRODUCT: 'rnd-product-ais',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'ProductAI') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllProductAIs(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        product: filter.product,
        ai: filter.ai,
        concentration_start: filter.concentrationStart,
        concentration_end: filter.concentrationEnd,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return await apiHelper(API_URL).get(`/${MODULE.PRODUCT}`, requestOptions)
}


export function updateProductAIStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.PRODUCT}/${data.id}`, requestOptions)
}

export function getProductAI(id) {
  return apiHelper(API_URL).get(`/${MODULE.PRODUCT}/${id}`)
}

export function updateProductAI(data) {
  const requestOptions = {
    product_uuid: data.productID,
    ai_uuid: data.aiID,
    concentration: data.concentration.toString(),
  }

  return apiHelper(API_URL).put(`/${MODULE.PRODUCT}/${data.id}`, requestOptions)
}

export function createProductAI(data) {
   
  const requestOptions = {
    product_uuid: data.productID,
    ai_uuid: data.aiID,
    concentration: data.concentration,
  }
  return apiHelper(API_URL).post(`/${MODULE.PRODUCT}`, requestOptions)
}